import { ProfileImage } from "../../../../assets";

export interface IRanking {
  avatarFileId: string;
  level: number;
  username: string;
  totalChips: number;
  exp: number;
  weeklyTournamentPoints?: number;
}

export enum RankingType {
  Total,
  ChipsTotal,
  ExpTotal,
  Tournaments,
}

export const rankings: IRanking[] = Array(24)
  .fill(null)
  .map((_, i) => {
    const level = Math.floor(Math.random() * 40) + 4; // Random Level in range 4-43

    return {
      avatarFileId: ProfileImage,
      level,
      username: "User-" + Math.floor(Math.random() * 2001),
      totalChips: level * 3 * Math.floor(Math.random() * 9999),
      exp: level * Math.floor(Math.random() * 999),
    };
  });
